import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `TipoDiluyente`, method: 'GET', body: null})
}